
const Help = () => {
  return (
    <div className="bg-slate-50 min-h-screen">

      {/* Hero */}
      <section className="bg-white">
        <div className="max-w-6xl mx-auto px-6 py-20 text-center">

          <span className="inline-flex rounded-full bg-sky-100 text-second px-4 py-1 text-sm font-medium">
            Help Center
          </span>

          <h1 className="different_heading mt-5 text-4xl lg:text-5xl font-bold text-slate-900">
            Need Help Creating a Support Ticket?
          </h1>

          <p className="mt-6 max-w-3xl mx-auto text-lg text-slate-600 leading-8">
            Follow these simple steps to sign in, submit a support request,
            and track its progress.
          </p>

        </div>
      </section>

      {/* Steps */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6">

          <div className="space-y-6">

            {[
              {
                title: "Log In",
                description:
                  "Sign in using your administrator email and password.",
              },
              {
                title: "Open Support",
                description:
                  "Navigate to the Support or Help Desk section from the dashboard.",
              },
              {
                title: "Create a Ticket",
                description:
                  "Click 'New Ticket' or 'Create Ticket' to start a new request.",
              },
              {
                title: "Describe Your Issue",
                description:
                  "Provide a subject, detailed description, priority, and attach screenshots if needed.",
              },
              {
                title: "Submit",
                description:
                  "Review your information and submit your support request.",
              },
              {
                title: "Track Progress",
                description:
                  "You'll receive confirmation and can monitor the ticket status from your dashboard.",
              },
            ].map((step, index) => (
              <div
                key={index}
                className="flex gap-6 rounded-2xl bg-white border border-slate-200 shadow-sm p-6"
              >
                <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-sky-600 text-white font-bold">
                  {index + 1}
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-slate-900">
                    {step.title}
                  </h3>

                  <p className="mt-2 text-slate-600 leading-7">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}

          </div>

        </div>
      </section>

      {/* Tips */}
      <section className="pb-20">
        <div className="max-w-4xl mx-auto px-6">

          <div className="rounded-3xl bg-white border border-slate-200 shadow-sm p-8">

            <h2 className="different_heading text-2xl font-bold text-slate-900">
              Helpful Tips
            </h2>

            <ul className="mt-6 space-y-4 text-slate-600">
              <li>✓ Make sure your administrator account has permission to create support tickets.</li>

              <li>✓ Include screenshots or error messages whenever possible.</li>

              <li>✓ Clearly describe the issue to help us resolve it faster.</li>

              <li>✓ Monitor your ticket status from the Support section.</li>
            </ul>

          </div>

        </div>
      </section>

    </div>
  );
};

export default Help;